<template>
    <div>
        <div class="content">
            <h1>{{ lang('Embed Codes') }}</h1>

            <p>{{ lang('Use portions of the event calendar system on other websites.') }}</p>

            <section>
                <b-tabs v-model="activeTab" type="is-boxed">
                    <b-tab-item :label="lang('Calendar')" icon-pack="fa" icon="calendar">
                        <h2>{{ lang('Calendar Plugin Code') }}</h2>

                        <b-field horizontal :label="lang('Types')">
                            <div class="field">
                                <b-checkbox v-model="allTypes" @input="resetTypes">
                                    {{ lang('All') }}
                                </b-checkbox>
                            </div>
                            <div class="field" v-for="type in eventTypes" :key="type">
                                <b-checkbox v-model="types" :native-value="type">
                                    {{ type }}
                                </b-checkbox>
                            </div>
                        </b-field>

                        <pre style="white-space:pre-wrap;"><code>{{ calendarCode }}</code></pre>
                    </b-tab-item>
                    <b-tab-item :label="lang('Event List')" icon-pack="fa" icon="list">
                        <h2>{{ lang('Event List Plugin Code') }}</h2>

                        <p>{{ lang('Return a list of upcoming events.') }}</p>


                        <b-field horizontal :label="lang('Types')">
                            <div class="field">
                                <b-checkbox v-model="allTypes" @input="resetTypes">
                                    {{ lang('All') }}
                                </b-checkbox>
                            </div>
                            <div class="field" v-for="type in eventTypes" :key="type">
                                <b-checkbox v-model="types" :native-value="type">
                                    {{ type }}
                                </b-checkbox>
                            </div>
                        </b-field>

                        <b-field horizontal :label="lang('Days')">
                            <b-input v-model="days" @input="loadListPreview"></b-input>
                        </b-field>

                        <b-field horizontal :label="lang('Search Tags')">
                            <b-taginput
                                v-model="tags"
                                ellipsis
                                :placeholder="lang('Add a keyword')"
                                @input="loadListPreview">
                            </b-taginput>
                        </b-field>

                        <b-field horizontal :label="lang('Element')">
                            <b-select v-model="el" @input="loadListPreview" :icon="elements[el].icon">
                                <option v-for="(label, el) in elements" :key="el" :value="el">{{ lang(label.label) }}</option>
                            </b-select>
                        </b-field>

                        <div class="columns">
                            <div class="column">
                                <h3>{{ lang('Preview') }}</h3>
                                <section v-html="listResponse"></section>
                            </div>

                            <div class="column">
                                <h3>{{ lang('Code') }}</h3>
                                <pre style="white-space:pre-wrap;"><code class="language-html" data-lang="html">{{ listCode }}</code></pre>
                            </div>
                        </div>

                    </b-tab-item>
                    <b-tab-item :label="lang('Open Status')" icon-pack="fa" icon="clock-o">
                        <h2>{{ lang('Open Status Plugin Code') }}</h2>

                        <p>{{ lang('Display `Open` or `Closed` status with next opening time.') }}</p>

                        <div class="columns">
                            <div class="column">
                                <h3>{{ lang('Preview') }}</h3>
                                <section v-for="location in locations" :key="`preview-${location.id}`" v-html="openStatusIframe(location.id)"></section>
                            </div>

                            <div class="column">
                                <h3>{{ lang('Code') }}</h3>
                                <div v-for="location in locations" :key="`code-${location.id}`">
                                    <h4>{{ location.name }}</h4>
                                    <pre style="white-space:pre-wrap;"><code class="language-html" data-lang="html">{{ openStatusCode(location.id) }}</code></pre>
                                </div>

                                <h3>{{ lang('Or Iframe') }}</h3>
                                <div v-for="location in locations" :key="`iframe-${location.id}`">
                                    <h4>{{ location.name }}</h4>
                                    <pre style="white-space:pre-wrap;"><code class="language-html" data-lang="html">{{ openStatusIframe(location.id) }}</code></pre>
                                </div>
                            </div>
                        </div>
                    </b-tab-item>
                </b-tabs>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: "Stats",
    data() {
        return {
            listResponse: '',
            openStatusResponse: '',
            activeTab: 1,
            formErrors: {},
            loading: false,
            days: 30,
            eventTypes: ['Offen', 'Privat', 'Kurs', 'Kindergeburtstag', 'Gruppe', 'Sonst', 'Geschlossen'],
            types: ['Offen'],
            allTypes: false,
            locations: [
                {
                    id: 1,
                    name: "OG",
                },
                {
                    id: 2,
                    name: "EG",
                },
            ],
            tags: [],
            elements: {
                'table': {
                    label: 'Table',
                    icon: 'table'
                },
                'ul': {
                    label: 'List',
                    icon: 'list'
                }
            },
            el: 'ul'
        };
    },
    methods: {
        /**
         * Load async data
         */
        loadListPreview() {
            let self = this;
            this.loading = true;

            var params = {
                days: self.days,
                types: self.types,
                tags: self.implodedTags,
                el: self.el
            };

            axios
                .get(`/events/list`, {params: params})
                .then(function(response) {
                    self.listResponse = response.data;
                    self.loading = false;
                })
                .catch(function(error) {
                    self.listResponse = '';
                    self.loading = false;
                    if (error.response.status == 401) {
                        // unauthorized
                        self.logout();
                    } else {
                        self.alertCustomError(error.response.data.message);
                    }
                });
        },
        loadOpenStatusPreview() {
            let self = this;
            this.loading = true;

            axios
                .get(`/events/open_status`)
                .then(function(response) {
                    self.openStatusResponse = response.data;
                    self.loading = false;
                })
                .catch(function(error) {
                    self.openStatusResponse = '';
                    self.loading = false;
                    if (error.response.status == 401) {
                        // unauthorized
                        self.logout();
                    } else {
                        self.alertCustomError(error.response.data.message);
                    }
                });
        },
        openStatusCode(locationId) {
            var id = Math.random().toString(36).substring(7);
            return `<script src="${this.$config.app.url}/js/plugin.js"><\/script>
<script>
    var id = 'open-status-${id}';
    document.write('<div id="' + id + '"></div>');
    window.onload = function() {
        kalender.init({
            'token': id,
            'url': '${this.$config.app.url}/events/open_status?location_id=${locationId}'
        });
    };
<\/script>`;
        },
        openStatusIframe(locationId) {
            return `<iframe src="${this.$config.app.url}/events/open_status?location_id=${locationId}" frameborder="0" scrolling="no" style="overflow:hidden;height:164px;width:100%"></iframe>`;
        },
        /**
         * Type style in relation to the value
         */
        type(value) {
            const number = parseFloat(value);
            if (number < 6) {
                return "is-danger";
            } else if (number >= 6 && number < 8) {
                return "is-warning";
            } else if (number >= 8) {
                return "is-success";
            }
        },
        resetTypes() {
            this.types = [];
        },
        alertCustomError(message) {
            this.$buefy.dialog.alert({
                title: "Error",
                message: message,
                type: "is-danger",
                hasIcon: true,
                icon: "times-circle"
            });
        },
        logout() {
            window.location.href = "/logout";
        }
    },
    filters: {

    },
    created() {
        // this.types = this.eventTypes;
    },
    mounted() {
        this.loadListPreview();
        this.loadOpenStatusPreview();
    },
    computed: {
        implodedTags() {
            return this.tags.join('|') || null;
        },
        listCode() {
            var id = Math.random().toString(36).substring(7);
            var types = '';
            this.types.forEach(function (value) {
                types += '&types[]=' + value;
            });
            return `<script src="${this.$config.app.url}/js/plugin.js"><\/script>
<script>
    var id = 'event-list-${id}';
    document.write('<div id="' + id + '"></div>');
    window.onload = function() {
        kalender.init({
            'token': id,
            'url': '${this.$config.app.url}/events/list?days=${this.days}${types}&el=${this.el}'
        });
    };
<\/script>`;
        },
        calendarCode() {
            var types = '';
            if (this.types.length) {
                types = '#/?types=' + this.types.join('&types=');
            }
            return `<iframe src="${this.$config.app.url}/Kalender${types}" frameborder="0" style="overflow:hidden;height:800px;width:100%"></iframe>`;
        }
    },
    watch: {
        types(value) {
            this.allTypes = this.types.length === 0;
            // buefy is firing the @click event before the value is updated,
            // so we need to use a watcher instead
            this.loadListPreview();
        }
    }
};
</script>
